import { apiCall } from '../../services/api-service';

export const handleBookingStatus = async (roomId,bookingDate, slot) => {
  console.log(slot)
    const response = await apiCall("get", `get_booking_details/${slot["id"]}`);
    console.log("Response:", response.data);
    return response.data;
  };

  export const getRemainderList = async () => {
        const response = await apiCall("get", "get_reminders");
        console.log("Response:", response.data);
        return response.data;
    };

    export const getRemainderDefaultApi = async () => {
      const response = await apiCall("get", "default_reminders");
      console.log("Response:", response.data);
      return response.data;
  };